import React from "react";
import { NavLink } from "react-router-dom";

export default function RightNavPanel({ title, subtitle, items = [], extra }) {
  return (
    <aside className="right-rail">
      <div className="right-rail-card">
        <p className="eyebrow">{title}</p>
        {subtitle ? <p className="muted">{subtitle}</p> : null}
        <nav className="right-nav-list">
          {items.map((item) => {
            const emphasis = item.to.includes("/preview") ? "emphasis" : "";
            return (
              <NavLink key={item.to} to={item.to} className={({ isActive }) => `right-nav-item ${emphasis} ${isActive ? "active" : ""}`}>
                <strong>{item.label}</strong>
                {item.note ? <span>{item.note}</span> : null}
              </NavLink>
            );
          })}
        </nav>
      </div>
      {extra ? <div className="right-rail-card">{extra}</div> : null}
    </aside>
  );
}
